import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_RightsIndividualsReceivingSvs = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_RightsIndividualsReceivingSvs' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Rights of Individuals Receiving Services</h3></p>
                <p className='w-750'>
                    I &nbsp;
                    <input placeholder='Name' type='text' id='txtName' name='txtName' className='add-only w-225 custom-add-only' /> &nbsp;
                    began receiving services provided by &nbsp;
                    <input placeholder='Name of Provider' type='text' id='txtNameProvider' name='txtNameProvider' className='add-only w-225 custom-add-only' /> &nbsp;
                    on &nbsp;
                    <input placeholder='Intake/Admission Date' type='date' id='txtIntakeAdmissionDate' name='txtIntakeAdmissionDate' className='add-only w-150 custom-add-only' /> &nbsp;
                    (Intake/Admission Date) and have been informed of the following.
                </p>
                <p className='w-750'>
                    1. My options within the program and of other services available
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    2. The program's rules and regulations
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    3. The responsibility of the program to refer me to another agency if this program becomes unable to serve me or meet my needs
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    4. My right to refuse treatment and withdraw from this program at any time
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    5. My right not to be subjected to corporal punishment or unethical treatment which includes my right to be free from any forms of abuse, neglect, exploitation or harassment and my right to be free from restraints of any form that are not medically necessary or are used as a means of coercion, discipline, convenience or retaliation by staff
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    6. My right to voice my opinions, recommendations and to file a written grievance which will result in program review and response without retribution
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    7. My right to be informed of and provided a copy of the local procedure for filing a grievance at the local level or with the DMH Office of Consumer Support
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    8. My right to privacy and confidentiality in respect of facility visitors in day programs , residential treatment programs, and community living programs as much as physically possible
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    9. My right regarding the program's nondiscrimination policies related to HIV infection and AIDS
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    10. My right to be treated with consideration, respect, and full recognition of my dignity and individual worth
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    11. My right to have reasonable access to the clergy and advocates and have access to legal counsel at all times
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    12. My right to review my records, except when restricted by law
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    13. My right to fully participate in and receive a copy of my Individual Service Plan/Plan of Services and Supports or Activity Plan. This includes 1:) having the right to make decisions regarding my care, being involved in my care planning and treatment and being able to request or refuse treatment 2;) having access to information in my case records within a reasonable time frame (5 days) or having the reason for not having access communicated to me; and, 3) having the right to be informed about any hazardous side effects of medication prescribed by staff medical personnel
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    14. My right to retain all Constitutional rights, except when restricted by due process and resulting court order
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    15. My right to have a family member or representative of my choice notified should I be admitted to a hospital
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    16. My right to receive care in a safe setting
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    17. My right to confidentiality regarding my personal information involving receiving services as  well as the compilation, storage, and dissemination of my individual case records in accordance weith standards  outlined by the Department of Mental Health and the Health Insurance Portability and Accountability Act of 1996 (HIPAA), if applicable
                </p>
                <p className='w-750'><hr /></p>


                <p className='w-750'>
                    Additionally, rights for individuals insupervised and residential treatment arrangements:
                </p>
                <p className='w-750'><hr /></p>


                <p className='w-750'>
                    18. My right to be provided a means of communicating with persons outside the program
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    19. My right to have visitation by close relatives and/or significant others during reasonable hours unless clinically contraindicated and documented in my case record
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    20. My righ to be provided with safe storage, accessibility, and accountability of my funds
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    21. My right to be permitted to send/receive mail without hindrance unless clinically contraindicated and documented in my case record
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    22. My right to be permittet do conduct private telephone conversations with family and friends, unless clinically
                </p>
                <p className='w-750'><hr /></p>



                <p className='w-750'>
                    I have been informed of, understand, and have received a written copy of the above information.
                </p>


            </div>
        </form >

    )
}











